export default __webpack_public_path__ + "media/assets/img/expand-more-0f4d7290c02ebad10bdce6dc098348f1.svg";